<template>
  <div>
    <v-tooltip bottom open-delay="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon class="ml-5" v-bind="attrs" v-on="on" @click="exportar">
          <v-icon>$MicrosoftExcel</v-icon>
        </v-btn>
      </template>
      <span>Exportar para excel</span>
    </v-tooltip>

    <form
      :action="URL"
      method="post"
      target="_blank"
      ref="submit-form-relatorio-categorias"
    >
      <input type="text" hidden name="items" :value="JSON.stringify(items)" />
      <input type="text" hidden name="parametros_excel" :value="JSON.stringify(parametros_excel)" />
    </form>

  </div>
</template>

<script>
import $axios from './../../../../../api/api.js';

export default {
  name: "ExportacaoGridParaExcel",
  props: {
    items: Array,
    parametros_excel: Object
  },
  computed: {
    URL(){
      const grupo = this.$store.getters['usuario/getGrupoCompras'];
      return `${$axios.defaults.baseURL}/relatorios/analise-geral-categoria-compras?grupo=${grupo}`;
    }
  },
  methods: {
    exportar() {
      this.$refs['submit-form-relatorio-categorias'].submit();
    }
  }
}
</script>

<style scoped>

</style>
